//dayjs
import dayjs from 'dayjs';
//yup
import * as Yup from 'yup';

export const phoneSchema = Yup.string()
  .trim()
  .matches(/^\+?[\d\s-]+$/, 'Must contain only digits')
  .min(6, 'Must be at least 6 characters')
  .max(15, 'Must be at most 15 characters');

export const passwordSchema = Yup.string()
  .required('Password is required')
  .matches(/^[A-Za-z0-9!@#$%^&*()_+=\-{}[\]:;"'<>,.?/]+$/, 'Only Latin characters are allowed')
  .min(8, 'Minimum 8 characters')
  .max(30, 'Maximum 30 characters');

export const emailSchema = Yup.string()
  .trim()
  .required('Email is required')
  .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, 'Invalid email format')
  .test('email is valid', 'Invalid email format', (value) => {
    if (!value) return true;
    return !!value.toLowerCase().match(validateEmailSchema);
  });

export const descriptionSchema = Yup.string()
  .required('Description is required')
  .min(5, 'Minimum description value 5 characters')
  .max(300, 'Maximum description value 5 characters');

export const logoOrImageSchema = Yup.mixed().nullable().required('Logo or Image is required');

export const validateEmailSchema = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

// export const expirationDateSchema = Yup.string().test('date is valid', 'Date has passed', (value) => {
//   if (!value) return true;

//   const isValid = !dayjs(value).isBefore(dayjs(), 'day') || dayjs(value).isSame(dayjs(), 'day');
//   return isValid;
// });

export const expirationDateSchema = Yup.string().test('expiration-date', 'Date has passed', function (value) {
  console.log(value, typeof value);
  if (!value) return true;

  const date = dayjs(value);

  if (!date.isValid()) {
    return this.createError({message: 'Enter a valid date'});
  }

  if (date.isBefore(dayjs(), 'day')) {
    return this.createError({message: 'Date has passed'});
  }

  return true;
});
